import { Controller } from "@hotwired/stimulus"
import Dropdown from 'bootstrap/js/dist/dropdown';


export default class extends Controller {

  static values = {
    formUrl: String
  }

  connect() {

    if(this.element.hasAttribute('template')) {
      return
    }

    // this.parent must be set to the previous element in the DOM
    this.parent = this.element.previousElementSibling;

    const toggle = this.element.querySelector('.dropdown-toggle');
    const menu = this.element.querySelector('.dropdown-menu');

    const dropdown = new Dropdown(toggle, {autoClose: false});
    dropdown._parent = this.element;
    dropdown._menu = menu;
    this.dropdown = dropdown;

    this.show();
    this.element.querySelectorAll('form').forEach((form) => {form.setAttribute('action', this.formUrlValue)});
    this.element.querySelector('.close').addEventListener('click', this.hide.bind(this));
  }

  show() {
    this.element.classList.remove('d-none');
    this.parent.setAttribute('data-paragraph-extension-form', 'true');

    if (!this._boundMouseLeaveListener) {
      this._boundMouseLeaveListener = this._mouseLeaveListener.bind(this);
      this._boundShow = this.show.bind(this);
    }
    document.addEventListener('click', this._boundMouseLeaveListener);
    this.parent.removeEventListener('click', this._boundShow);

    // We have to wait a little bit before showing the dropdown.
    // Otherwise, I think, the dropdown will be hidden by the click event that triggered the show method.
    setTimeout(() => {
      this.dropdown.show();
    }, 1);
  }

  hide() {
    setTimeout(() => {
      this.element.classList.add('d-none');
      this.parent.removeAttribute('data-paragraph-extension-form');
      document.removeEventListener('mouseleave', this._boundMouseLeaveListener);
      this.parent.addEventListener('click', this._boundShow);
      this.dropdown.hide()
    }, 1);
  }

  _mouseLeaveListener(e) {
    if (!this.element.contains(e.target) && !this.parent.contains(e.target)) {
      this.hide()
    }
  }
}
